import { Component } from '@angular/core';

@Component({
  selector: "sot-backbtn",
  templateUrl: "./backbtn.component.html",
  styleUrls: ["./backbtn.component.scss"]
})
export class BackBtn {
  constructor() {}
}